import { Component, OnInit, ViewEncapsulation } from '@angular/core';
import { Router } from '@angular/router';
import { PixMenu } from '../models/pix-menu.enum';

@Component({
	selector: 'app-pix-payment-key',
	templateUrl: './payment-key.component.html',
	styleUrls: ['./payment-key.component.styl'],
	encapsulation: ViewEncapsulation.None
})
export class PixPaymentKeyComponent implements OnInit {

	constructor(
		private router: Router
	) {}

	ngOnInit(): void {
	}

	get pixMenu(): typeof PixMenu {
		return PixMenu;
	}

}



// WEBPACK FOOTER //
// /home/ubuntu/workdir/workspace/Front End Angular (NGINX)/omni-internetbanking/hmg-omni-internetbanking-deploy/src/app/master/pix/payment-key/payment-key.component.ts